const TRUE_VALUES = new Set(['1', 'true', 'yes', 'on']);

function isTrue(value?: string | null): boolean {
  if (!value) return false;
  return TRUE_VALUES.has(value.trim().toLowerCase());
}

function getRuntimeDebugFlag(): boolean {
  if (typeof window === 'undefined') return false;

  const win = window as Window & {
    DEBUG_MODE?: boolean | string;
    __DEBUG_MODE__?: boolean | string;
  };

  if (typeof win.DEBUG_MODE === 'boolean') return win.DEBUG_MODE;
  if (typeof win.__DEBUG_MODE__ === 'boolean') return win.__DEBUG_MODE__;

  if (typeof win.DEBUG_MODE === 'string' && isTrue(win.DEBUG_MODE)) return true;
  if (typeof win.__DEBUG_MODE__ === 'string' && isTrue(win.__DEBUG_MODE__)) return true;

  try {
    return isTrue(window.localStorage.getItem('DEBUG_MODE'));
  } catch {
    return false;
  }
}

export function isDebugModeEnabled(): boolean {
  return isTrue(process.env.REACT_APP_DEBUG_MODE) || isTrue(process.env.DEBUG_MODE) || getRuntimeDebugFlag();
}

export function configureConsoleDebugMode(): void {
  if (typeof window === 'undefined') return;

  const win = window as Window & { __CONSOLE_DEBUG_CONFIGURED__?: boolean };
  if (win.__CONSOLE_DEBUG_CONFIGURED__) return;
  win.__CONSOLE_DEBUG_CONFIGURED__ = true;

  if (isDebugModeEnabled()) return;

  const methods: Array<'log' | 'info' | 'debug' | 'warn' | 'error' | 'trace'> = [
    'log',
    'info',
    'debug',
    'warn',
    'error',
    'trace',
  ];

  for (const method of methods) {
    console[method] = () => {};
  }
}
